import { ToastContentProps } from 'react-toastify';
import { UnregisteredUnit } from '../models/model';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';

type Props = Partial<ToastContentProps> & {
  unregisteredUnits: UnregisteredUnit[];
};

const UnregisteredUnitToastMsg = ({ unregisteredUnits }: Props) => {
  const { t } = useTranslation();
  const uniqueUnits = _.uniqBy(unregisteredUnits, 'purchase_master_cd');
  return (
    <div className="custom-toast">
      <div style={{ marginBottom: '0.7rem' }} className="unit-error">
        <div className="mb-2">
          <b>補助単位コード３</b>
          {t('PartsConfigurationDetail.dialog.title')}
          {uniqueUnits
            .filter((unit) => !unit.supplementary_unit_cd_3)
            .map((unit, index) => (
              <div key={index}>
                {t('PartsConfigurationDetail.dialog.composition_cd')}
                {unit.process_master_cd || unit.purchase_master_cd}
                <span>&nbsp;&nbsp;</span>
                {t('PartsConfigurationDetail.dialog.composition_name')}
                {unit.process_item_name || unit.purchase_item_name}
              </div>
            ))}
        </div>
        <div>
          <b>補助単位換算率３</b>
          {t('PartsConfigurationDetail.dialog.title')}
          {uniqueUnits
            .filter((unit) => !unit.supplementary_unit_cd_3)
            .map((unit, index) => (
              <div key={index}>
                {t('PartsConfigurationDetail.dialog.composition_cd')}
                {unit.process_master_cd || unit.purchase_master_cd}
                <span>&nbsp;&nbsp;</span>
                {t('PartsConfigurationDetail.dialog.composition_name')}
                {unit.process_item_name || unit.purchase_item_name}
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};

export default UnregisteredUnitToastMsg;
